import { stableSceneStringify } from '@/utils/designStudioSceneSession.js'

export function thumbnailIdentityKey(item) {
  if (!item) return ''
  if (item.id != null) return `id:${item.id}`
  return `new:${item.item_sort ?? ''}:${item.imagedata?.id ?? item.imagedata?.local_id ?? ''}`
}

export function thumbnailRenderHash(item) {
  if (!item) return ''
  const configData = { ...(item.config_data || {}) }
  // Wall coordinates do not affect an isolated thumbnail render.
  delete configData.wall_offset_x
  delete configData.wall_offset_y
  return stableSceneStringify({
    imagedata: item.imagedata || null,
    width: item.width ?? null,
    height: item.height ?? null,
    config_data: configData,
  })
}

export function thumbnailPreparedCacheKey(item, hash = thumbnailRenderHash(item)) {
  const itemKey = thumbnailIdentityKey(item)
  return itemKey && hash ? `${itemKey}:${hash}` : ''
}
